import { useCallback, useState } from "react";

const useForceRerender = () => {
  const [, setForceRerender] = useState({});

  const rerender = useCallback(() => {
    setForceRerender({});
  }, []);

  return rerender;
};

export default useForceRerender;
